import { useUserPreferences } from "components/UserPreferences/UserPreferencesContext"
import { Logger } from "lib/logging"
import { DateTime } from "luxon"

interface PlainDateProps {
  date: DateTime
  format?: string
}

export const PlainDate = ({ date, format }: PlainDateProps): React.JSX.Element => {
  const { locale } = useUserPreferences()
  return <>{date.setLocale(locale).toFormat(format ?? getDefaultDateFormat(locale))}</>
}

export function formatPlainDate(
  date: DateTime,
  opts: { locale: string } | { format: string },
): string {
  const format = "format" in opts ? opts.format : getDefaultDateFormat(opts.locale)
  return date.toFormat(format)
}

export function getDefaultDateFormat(locale: string): string {
  return new Intl.DateTimeFormat(locale)
    .formatToParts(new Date(2022, 10, 30))
    .map(({ type, value }) => {
      switch (type) {
        case "year":
          return "yyyy"
        case "month":
          return "MM"
        case "day":
          return "dd"
        case "literal":
          return value
        default:
          Logger.info(`${type} is not supported in #getDefaultDateFormat`)
          return ""
      }
    })
    .join("")
}
